import { create } from "zustand";

interface SubscriberState {
  loading: boolean;
  success: boolean;
  error: string | null;
  subscribe: (email: string, recaptcha_token: string) => Promise<void>;
  reset: () => void;
}

export const useSubscriberStore = create<SubscriberState>((set) => ({
  loading: false,
  success: false,
  error: null,

  subscribe: async (email: string, recaptcha_token: string) => {
    try {
      set({ loading: true, error: null, success: false });

      const formData = new FormData();
      formData.append("email", email);
      formData.append("recaptcha_token", recaptcha_token);

      const response = await fetch(
        "https://admin-talentlink.digiline.id/api/en/subscriber",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.message || "Failed to subscribe");
      }

      set({ success: true });
    } catch (error: any) {
      set({ error: error.message || "Something went wrong" });
    } finally {
      set({ loading: false });
    }
  },

  reset: () => set({ success: false, error: null }),
}));
